import type { CSSProperties } from 'react';
import { getPalette } from '@/config/colors';
import type { AccentPalette, ColorToken } from '@/types';

/**
 * Projects a palette onto the design-system accent variables. Apply together
 * with `data-accent` so the light/dark variants of the tint and the text
 * colour resolve from CSS rather than from JavaScript.
 */
export function accentStyle(palette: AccentPalette): CSSProperties {
  return {
    '--accent': palette.base,
    '--accent-hover': palette.hover,
    '--accent-fg': palette.foreground,
    '--accent-ring': `${palette.base}2e`,
    '--accent-soft-light': palette.soft,
    '--accent-soft-dark': palette.softDark,
    '--accent-text-light': palette.text,
    '--accent-text-dark': palette.textDark,
    '--accent-wash-strong': `${palette.base}30`,
    '--accent-wash-soft': `${palette.base}0d`,
    '--ill-accent': palette.base,
  } as CSSProperties;
}

/** Convenience: resolve a colour token straight to inline accent variables. */
export function tokenAccentStyle(token: ColorToken): CSSProperties {
  return accentStyle(getPalette(token));
}
